import React, {useEffect, useState, useMemo} from "react";
import {Table, Input, Button, Row, Menu, Col, notification} from "antd";
import Icons from "assets/icons";
import {listExamination, examOutService} from "api";
import {DataTableMenu} from "./AllocateTableSearch.config";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {EXAMINATION_ACTION_TYPE} from "types/enums/examination";
import {setAction} from "redux/reducer/examination";
import type {MenuProps} from "antd";
import "./AllocateTableSearch.scss";
import { Notification } from "components/common";

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group"
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

const AllocateTableSearch = () => {
  let dispatch = useAppDispatch();
  const action = useAppSelector(state => state.examination);
  const [listDMBoChiDinh, setListDMBoChiDinh] = useState<any>(null);
  const [searchBCD, setSearchBCD] = useState<any>([]);
  const [dMNhomDichVu, setDMNhomDichVu] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [tableData, setTableData] = useState<Array<DataTableMenu> | null>(null);
  const [reload, setReload] = useState<boolean>(true);
  const [selectedBCD, setSelectedBCD] = useState<any>(null);
  const [searchNDV, setSearchNDV] = useState<any>([]);
  const [selectedMenuKeys, setSelectedMenuKeys] = useState<any>([]);
  const [selectedTableKeys, setSelectedTableKeys] = useState<any>([]);
  const bcdColumns = [
    {
      title: "STT",
      key: "stt",
      render: (v, r, i) => i + 1,
      align: "center",
    },
    {
      title: "Tên bộ chỉ định",
      key: "tenBoChiDinh",
      dataIndex: "tenBoChiDinh",
    },
  ];

  const getListDMBoChiDinh = async (params?: any) => {
    try {
      setLoading(true);
      let response = await listExamination.getListDMBoChiDinh();
      setListDMBoChiDinh(response.data);
      setSearchBCD(response.data);
      setLoading(false);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };
  const getDMNhomDichVu = async (params?: any) => {
    try {
      setLoading(true);
      let response = await listExamination.getDMNhomDichVu();
      setDMNhomDichVu(response.data.roots);
      setSearchNDV(response.data.roots);
      setLoading(false);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };
  const searchDMDichVu = async (value) => {
    try {
      let response = await examOutService.searchDMDichVu({
        tenDichVu: value
      })
      dispatch(
        setAction({
          actionType: EXAMINATION_ACTION_TYPE.SEARCHDMDV,
          dataPassing: response,
        })
      );
    } catch (err) {
      
    }
  }
  const onClickNDV = ndv => {
    dispatch(
      setAction({
        actionType: EXAMINATION_ACTION_TYPE.CLICKNDV,
        dataPassing: ndv,
      })
    );
  };
  const ndvLabel = dt => {
    return <div onClick={() => onClickNDV(dt)}>{dt.tenNhomDichVu}</div>;
  };
  const mapChildren = (data, sub) => {
    let subIdx = 1;
    if (data.children?.length > 0) {
      return getItem(
        data.tenNhomDichVu,
        sub + '-' + subIdx,
        null,
        data.children.map((it, index) => mapChildren(it, sub + '-' + subIdx + '-' + index))
      );
    }
    return getItem(ndvLabel(data), data.tenNhomDichVu);
  };

  const clickBCD = bcd => {
    dispatch(
      setAction({
        actionType: EXAMINATION_ACTION_TYPE.CLICKBCD,
        dataPassing: bcd,
      })
    );
    setSelectedMenuKeys([])
    setSelectedTableKeys([bcd.id])
  };
  const onBCDChange = (selectedRowKeys, selectedRows, info) => {
    setSelectedBCD(selectedRows[0]);
    setSelectedTableKeys(selectedRowKeys);
    setSelectedMenuKeys([])
    clickBCD(selectedRows[0]);
  };
  const getItemsBCD = bcd => {
    let sub = "sub";
    let subIdx = 1;
    const it1 = getItem(
      "Bộ chỉ định",
      sub + subIdx,
      null,
      bcd.map(it =>
        getItem(
          <div onClick={() => clickBCD(it)}>{it.tenBoChiDinh}</div>,
          it.tenBoChiDinh
        )
      )
    );
    return [it1];
  };
  const onMenuSelect = async ({ item, key, keyPath, selectedKeys, domEvent }) => {
    setSelectedMenuKeys(selectedKeys)
    setSelectedTableKeys([])
  }
  const onSearchDMDichVu = async (e) => {
    searchDMDichVu(e.target.value);
    setSelectedMenuKeys([])
    setSelectedTableKeys([])
  }
  const getItemsDMN = dmn => {
    let sub = "sub";
    let subIdx = 1;
    const it2 = getItem(
      "Tất cả",
      sub + '-' + subIdx,
      null,
      dmn.map((it, index) => {
        let tmp = sub + '-' + subIdx + '-' + index
        return mapChildren(it, tmp)
      })
    );
    return [it2];
  };

  const bcdSearch = async e => {
    const value = e.target.value;
    if (value === "") {
      setSearchBCD([...listDMBoChiDinh]);
    } else {
      const filteredResult = listDMBoChiDinh.filter(row =>
        row.tenBoChiDinh.toLowerCase().includes(value.toLowerCase())
      );
      setSearchBCD(filteredResult);
    }
  };

  const dmnSearch = async e => {
    const value = e.target.value;
    // if (value === "") {
    //   setSearchNDV([...dMNhomDichVu]);
    // } else {
    //   var tmp = []
    //   dMNhomDichVu.map(it => {
    //     if(it.tenNhomDichVu.toLowerCase().includes(value.toLowerCase()))
    //       tmp = [...tmp, it]
    //   })
    //   setSearchNDV(tmp)
    // }
  };

  const onBCDDelete = async () => {
    if (searchBCD) {
      let response = await listExamination.deleteBCD({
        idBoChiDinh: action.dataPassing.id,
      });
      if (response.status == 200) {
        Notification("success", "Xoá bộ chỉ định thành công");
        dispatch(
          setAction({
            actionType: EXAMINATION_ACTION_TYPE.DELETEBCD,
            dataPassing: null,
          })
        );
      }
    }
  };
  const menuItems = useMemo(() => {
    return getItemsDMN(searchNDV);
  }, [searchNDV]);
  useEffect(() => {
    if (action.actionType == EXAMINATION_ACTION_TYPE.ADDEDNEWBCD) {
      setReload(true);
    }
    if (action.actionType == EXAMINATION_ACTION_TYPE.DELETEBCD) {
      setReload(true);
    }
  }, [action]);
  useEffect(() => {
    if (reload) {
      getListDMBoChiDinh();
      getDMNhomDichVu();
      setReload(false);
    }
  }, [reload]);
  useEffect(() => {}, [searchBCD, searchNDV]);
  return (
    <Row className="allocate-table-search" gutter={[8, 8]}>
      {listDMBoChiDinh ? (
        <Row gutter={[8, 8]}>
          <Row justify="space-between" gutter={[8, 8]}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Input
                placeholder="Tìm kiếm"
                suffix={<Icons.search />}
                onChange={bcdSearch}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Row justify={"end"}>
                <Button
                  type="primary"
                  icon={<Icons.remove />}
                  danger
                  onClick={onBCDDelete}
                >
                  Xoá bộ CĐ
                </Button>
              </Row>
            </Col>
          </Row>
          <Table
            rowKey={record => record.id}
            columns={bcdColumns}
            dataSource={searchBCD}
            pagination={false}
            loading={loading}
            rowSelection={{
              type: "radio",
              onChange: onBCDChange,
              selectedRowKeys: selectedTableKeys
            }}
            bordered
            onRow={(record, idex) => {
              return {
                onDoubleClick: () => clickBCD(record),
              };
            }}
          />
        </Row>
      ) : null}
      <Row>
        <Input
          placeholder="Nhập và Enter"
          suffix={<Icons.search />}
          onPressEnter={onSearchDMDichVu}
        />
        <Menu
          key={"menu-bcd"}
          style={{width: "100%"}}
          selectedKeys={selectedMenuKeys}
          mode="inline"
          items={menuItems}
          onSelect={onMenuSelect}
        />
      </Row>
    </Row>
  );
};

export default AllocateTableSearch;
